module.exports = __webpack_public_path__ + "img/holly-berry.60a6e526.svg";